export function PrivacyPolicy() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <h1 className="mb-8 text-3xl font-bold tracking-tight">Privacy Policy</h1>
      <p className="mb-4 text-sm text-gray-500">Last updated: June 2026</p>

      <section className="space-y-6 text-gray-700 dark:text-gray-300 [&_h2]:mb-2 [&_h2]:mt-8 [&_h2]:text-xl [&_h2]:font-semibold [&_ul]:ml-6 [&_ul]:list-disc [&_ul]:space-y-1">
        <p>
          BidConvey (Pty) Ltd (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) operates
          the BidConvey conveyancing appointment platform. This Privacy Policy
          explains how we collect, use, store, and protect your personal
          information in compliance with the Protection of Personal Information
          Act, 2013 (POPIA).
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>Name and email address (at registration)</li>
          <li>Property details you submit in a Request for Quotation (RFQ)</li>
          <li>Bid and service-offering information (conveyancers)</li>
          <li>Payment confirmation references</li>
          <li>Browser type and IP address (automatically)</li>
        </ul>

        <h2>2. Purpose of Processing</h2>
        <p>We process your personal information to:</p>
        <ul>
          <li>Create and manage your account</li>
          <li>Match property buyers with registered conveyancers</li>
          <li>Facilitate the sealed-bid process and conveyancer selection</li>
          <li>Process and verify payments</li>
          <li>Send transactional emails (RFQ status, bid notifications)</li>
          <li>Comply with legal and regulatory obligations</li>
        </ul>

        <h2>3. Legal Basis</h2>
        <p>
          We rely on your consent (given at registration) and the
          performance of a contract to process your personal information.
          For payment records, we also rely on legal obligations under the
          Tax Administration Act.
        </p>

        <h2>4. Data Sharing</h2>
        <p>We do not sell your personal information. We share data only:</p>
        <ul>
          <li>Between platform portals as required for the conveyancing workflow (e.g. the seller portal receives quotation details without pricing information)</li>
          <li>With email service providers (Resend) for transactional notifications</li>
          <li>When required by law or valid court order</li>
        </ul>

        <h2>5. Data Retention</h2>
        <p>
          User accounts are retained until you request deletion or 3 years
          after last login. Transactional records (RFQs, bids, selections)
          are retained for 5 years for financial reporting purposes. Payment
          records are retained for 7 years per SARS requirements. See our
          full data retention policy for details.
        </p>

        <h2>6. Your Rights (POPIA Sections 23&ndash;25)</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal information we hold about you</li>
          <li>Request correction of inaccurate information</li>
          <li>Request deletion of your account and personal data</li>
          <li>Object to the processing of your personal information</li>
          <li>Withdraw consent at any time</li>
        </ul>
        <p>
          To exercise these rights, use the &ldquo;Delete Account&rdquo; option in
          your profile settings or contact us at{" "}
          <a href="mailto:privacy@bidconvey.co.za" className="underline font-medium">
            privacy@bidconvey.co.za
          </a>.
        </p>

        <h2>7. Security</h2>
        <p>
          We protect your information using industry-standard measures
          including encrypted connections (TLS), hashed passwords (bcrypt),
          HMAC-signed inter-service communication, and role-based access
          controls.
        </p>

        <h2>8. Cookies</h2>
        <p>
          We use essential cookies to maintain your authenticated session.
          We do not use tracking cookies or third-party analytics cookies.
        </p>

        <h2>9. Changes to This Policy</h2>
        <p>
          We may update this policy from time to time. The &ldquo;Last
          updated&rdquo; date at the top indicates when it was last revised.
          Continued use of the platform constitutes acceptance of the
          revised policy.
        </p>

        <h2>10. Contact</h2>
        <p>
          Information Officer: BidConvey (Pty) Ltd<br />
          Email:{" "}
          <a href="mailto:privacy@bidconvey.co.za" className="underline font-medium">
            privacy@bidconvey.co.za
          </a>
        </p>
      </section>

      <div className="mt-12">
        <a href="/" className="text-sm font-medium text-blue-600 hover:underline">
          &larr; Back to home
        </a>
      </div>
    </div>
  );
}
